export const getVodItemUrl = (vodItem) => {
  if (!vodItem || typeof vodItem !== "object" || vodItem.id === undefined)
    return undefined;

  return `/vod/${vodItem.id}`;
};
